import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';

import { YatLogo } from '@pkg/assets/brand';
import { Typography } from '@pkg/components';
import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { NFT_OUTLINE_OFFSET, StyledYatAnimatedOutline } from '@app/pages/Prototype/Grid/GridItem/NFT/styles';

import { useWalletSync } from './useWalletSync';

import { NftCardsEmptyWrapper, StyledNoNftColumn, StyledYatHandWrap } from './styles';

export interface NftCardsEmptyProps {
    hasSyncedWallets?: boolean;
    onClose: () => void;
}

export function NftCardsEmpty({ hasSyncedWallets = false, onClose }: NftCardsEmptyProps) {
    const [translate] = useTranslation('nft');
    const theme = useContext(ThemeContext);

    const handleSyncWallet = useWalletSync();

    function closePanel() {
        onClose();
    }

    function handleClose() {
        handleSyncWallet();
        closePanel();
    }

    const copy = hasSyncedWallets
        ? {
              title: translate('looks_empty'),
              body: translate('your_wallet_is_synced'),
              cta: translate('connect_another_wallet'),
          }
        : {
              title: translate('looks_empty'),
              body: translate('no_wallet_connected'),
              cta: translate('connect_wallet'),
          };

    return (
        <NftCardsEmptyWrapper>
            <StyledNoNftColumn>
                <Typography size={30} color="inherit" type="headline">
                    {copy.title}
                </Typography>
                <Typography color="inherit" size={18} type="paragraph">
                    {copy.body}
                </Typography>

                <Button size="large" onClick={handleClose}>
                    {copy.cta}
                </Button>
            </StyledNoNftColumn>

            <StyledNoNftColumn>
                <StyledYatAnimatedOutline
                    outlineOffset={NFT_OUTLINE_OFFSET}
                    primaryColor={theme.colors.pink}
                    secondaryColor={theme.colors.purple}
                />

                <StyledYatHandWrap>
                    <YatLogo />
                </StyledYatHandWrap>
            </StyledNoNftColumn>
        </NftCardsEmptyWrapper>
    );
}
